import { QueryFunctionContext } from '@tanstack/react-query';
import { apiEditor } from 'services/api/api';
import { EditorApiEndpoints } from 'utils/endpoints/endpoints';
import { appendQueryParams } from 'utils/requestUtils';
import { IArquivoEditavel } from 'utils/types/arquivoEditavel';
import { IBlocoRegistroCategoria } from 'utils/types/blocoCategoria';
import { IRegistroExibicao } from 'utils/types/registroExibicao';

export const fetchDadosArquivoEditavel = async (
  context: QueryFunctionContext<
    [string, number | undefined, string | undefined]
  >,
): Promise<IArquivoEditavel> => {
  const [, usuarioID, processamentoID] = context.queryKey;
  const queryParams = { usuarioID, processamentoID };
  const res = await apiEditor.get<IArquivoEditavel>(
    appendQueryParams(EditorApiEndpoints.GetArquivoEditavel, queryParams),
  );
  return res.data;
};

export const fetchBlocoCategoria = async (): Promise<
  IBlocoRegistroCategoria[]
> => {
  const res = await apiEditor.get<IBlocoRegistroCategoria[]>(
    EditorApiEndpoints.GetBlocoCategoria,
  );
  return res.data;
};

export const fetchRegistroCategoria = async (
  context: QueryFunctionContext<[string, number | null]>,
): Promise<IBlocoRegistroCategoria[]> => {
  const [, blocoCategoriaID] = context.queryKey;
  const queryParams = { blocoCategoriaID };
  const res = await apiEditor.get<IBlocoRegistroCategoria[]>(
    appendQueryParams(EditorApiEndpoints.GetRegistroCategoria, queryParams),
  );
  return res.data;
};

export const fetchArquivosStatus = async (
  context: QueryFunctionContext<[string, string | undefined]>,
): Promise<string> => {
  const [, processamentoID] = context.queryKey;
  const queryParams = { processamentoID };
  const res = await apiEditor.get(
    appendQueryParams(EditorApiEndpoints.GetStatusArquivo, queryParams),
  );
  return res.data;
};

export const fetchRegistros = async (
  context: QueryFunctionContext<[string, number | null, number | null]>,
): Promise<IRegistroExibicao[]> => {
  const [, registroCategoriaID, blocoCategoriaID] = context.queryKey;
  const res = await apiEditor.get(
    appendQueryParams(`${EditorApiEndpoints.GetCodigoRegistros}${registroCategoriaID}/registros`, 
      { categoriaBlocoId: blocoCategoriaID}),
  );
  return res.data;
};
